var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a596197b-8e5c-4389-8847-6dfa625d0652",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aec121e8-00a4-459c-9508-d5a889b6d90b",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b0108475-b315-4dcf-9950-45c32a7bd923",
    "data-name": "Path 14",
    d: "M19.131,17.592l-4.368-4.368a7.828,7.828,0,1,0-1.536,1.537L17.6,19.13a.672.672,0,0,0,.95,0l.587-.587a.672.672,0,0,0,0-.95M8.505,14.424a5.924,5.924,0,1,1,4.188-1.735,5.923,5.923,0,0,1-4.188,1.735",
    style: {
      fill: "#6e6e6e"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxSearch);
export default __webpack_public_path__ + "static/media/bxSearch.6248eeb33ff293dbd20a7c4b1502096e.svg";
export { ForwardRef as ReactComponent };